import { collectorKeys } from '@/hooks/api/useCollectors'
import { subscriptionKeys } from '@/hooks/api/useSubscriptions'
import { QueryClient } from '@tanstack/react-query'

export const invalidateAgreementCache = (
  queryClient: QueryClient,
  agreementId: string,
) => {
  queryClient.invalidateQueries({ queryKey: subscriptionKeys.subscriptions(agreementId) })
  queryClient.invalidateQueries({ queryKey: subscriptionKeys.installments(agreementId) })
  queryClient.invalidateQueries({ queryKey: ['agreement-payments', agreementId] })
  queryClient.invalidateQueries({ queryKey: ['accounts', agreementId] })
}

export const invalidateAgreementCacheWithLists = (
  queryClient: QueryClient,
  agreementId: string,
) => {
  invalidateAgreementCache(queryClient, agreementId)
  queryClient.invalidateQueries({ queryKey: subscriptionKeys.lists() })
}

export const invalidateCollectorAndAgreementCache = (
  queryClient: QueryClient,
  agreementId: string,
) => {
  queryClient.invalidateQueries({ queryKey: collectorKeys.all })
  invalidateAgreementCache(queryClient, agreementId)
}
